import React, { useState } from 'react';
import { EmulateUserDialog } from './EmulateUserDialog';

export const useEmulateUserDialog = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);
  const dialog = <EmulateUserDialog onClose={toggle} open={open} />;
  return [toggle, dialog];
};
